import React from 'react';
import PropTypes from 'prop-types';

import PopupLink from '../PopupLink';
import GiftaidPopupText from '../../01_atoms/GiftaidPopupText';
import Button from '../../01_atoms/Button';
import programmeStyles from '../../03_organisms/BodyBlocks/BBProgramme/index.module.scss';
import FormattedText from '../../01_atoms/FormattedText';

import styles from './index.module.scss';

const GiftAidQuestion = ({
  heading = '',
  text = '',
  onAccept,
  onCancel,
  variant = 'donation-form',
  buttonType = 'primary',
}) => (
  <div className={`${styles['giftaid-question']} ${styles[`giftaid-question--${variant}`]}`}>
    <img src="/static/images/giftaid.png" alt="Giftaid" width={230} height={92} />

    {heading && <h2 className={styles['giftaid-question__heading']}>{heading}</h2>}
    {text && <FormattedText text={text} />}

    <p>
      I am a UK taxpayer and I would like Concern to reclaim the tax I have paid on this donation,
      any donation I have made in the previous four years, and any donations I may make in the
      future. The Gift Aid claimed will help fund Concern’s work to end extreme poverty.&nbsp;
      <PopupLink className={programmeStyles['popup-programme']} linkText="More Info">
        <GiftaidPopupText />
      </PopupLink>
    </p>

    <div>
      <Button
        data-analytics="giftaid-boost-button"
        type={buttonType}
        size="large"
        tag="a"
        onClick={() => onAccept()}
      >
        Yes, boost my donation
      </Button>
    </div>

    <div>
      <Button type={buttonType} size="large" tag="a" isOutlined onClick={() => onCancel()}>
        No, thanks
      </Button>
    </div>
  </div>
);

GiftAidQuestion.propTypes = {
  heading: PropTypes.string,
  text: PropTypes.string,
  onAccept: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['donation-form', 'inline-donation-form']),
  buttonType: PropTypes.oneOf(['primary', 'emergency']),
};

export default GiftAidQuestion;
